import { Component, Optional } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatProgressSpinnerModule],
  templateUrl: 'dialog-stampa.component.html',
  styleUrls: ['dialog-stampa.component.scss']
})
export class DialogStampaContent {
  constructor(@Optional() public dialogRef: MatDialogRef<DialogStampaContent>) {}

  closeDialog(valore: String) {
    if (valore === '0') {
      this.dialogRef.close(valore);
      return;
    }
    this.dialogRef.close(valore);
  }
}
